import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { AppModule } from './app/app.module';
import { environment } from './environments/environment';

// Silence the browser console when `environment.silenceConsole` is on
// (currently real prod only — staging keeps logs so QA can debug
// without a separate build). Runtime override — every `console.*`
// call still exists in the bundle, it just hits a no-op. Done before
// anything else in main.ts so any third-party script that wires its
// own console listeners later still sees the noop'd methods. Kept
// browser-only (this file is the browser entry paired with
// main.server.ts) so SSR logs continue to flow to the server's
// stdout where ops actually need them.
if (environment.silenceConsole) {
  const noop = (): void => undefined;
  console.log = noop;
  console.info = noop;
  console.debug = noop;
  console.warn = noop;
  console.error = noop;
  console.trace = noop;
  console.dir = noop;
  console.table = noop;
}

// Inject the BillDesk WebSDK script using the env-configured URL —
// prod hits pay.billdesk.com, lower envs hit the uat1 sandbox.
// Lives here (browser-only entry, paired with main.server.ts) so it
// never runs on the SSR side. Kicks off the request before bootstrap
// so the SDK is almost always ready by the time the user reaches
// checkout and clicks Pay.
if (environment.billdeskSdkUrl) {
  const billdeskSdkScript = document.createElement('script');
  billdeskSdkScript.type = 'module';
  billdeskSdkScript.src = environment.billdeskSdkUrl;
  document.head.appendChild(billdeskSdkScript);
}

platformBrowserDynamic().bootstrapModule(AppModule)
  .catch(err => console.error(err));
